import { TODO } from '@b2b/types/core';
import { IInjectable } from '@uirouter/angularjs';
import { ApiService } from '../services/api/types';

export function FormsCustomFieldsDataResolver(): IInjectable {
  return [
    'ApiService',
    'HelpersService',
    function (ApiService: ApiService, HelpersService: TODO) {
      return ApiService.form.customFields.list(HelpersService.getPaginator());
    },
  ];
}
